import Popup from '../../../components/general/Popup.tsx';

type DeleteDocumentPopupProps = {
    open: boolean;
    isDeleting: boolean;
    unmatchesFirst?: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

export function DeleteDocumentPopup({
    open,
    isDeleting,
    unmatchesFirst = false,
    onClose,
    onConfirm,
}: DeleteDocumentPopupProps) {
    return (
        <Popup
            open={open}
            onClose={onClose}
            onConfirm={onConfirm}
            title={unmatchesFirst ? 'Ontkoppelen en verwijderen' : 'Document verwijderen'}
            variant="danger"
            confirmButtonDisplayLabel={unmatchesFirst ? 'Ontkoppelen en verwijderen' : 'Verwijderen'}
            confirmButtonDisabled={isDeleting}
            confirmOnEnter
        >
            <p className="text-sm text-gray-700">
                {unmatchesFirst
                    ? 'Dit document is gekoppeld aan een betaling. De koppeling wordt verwijderd en daarna wordt het document verwijderd.'
                    : 'Weet je zeker dat je dit document wilt verwijderen?'}
            </p>
        </Popup>
    );
}
